<template>
  <a-modal title="编辑指标项" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 4 }"
      :wrapperCol="{ span: 18 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="指标项：" prop="name">
        <a-input v-model="form.name" placeholder="请输入指标项" />
      </a-form-model-item>
      <!--<a-form-model-item label="建议：">-->
      <!--  <a-textarea v-model="form.suggestion" :rows="4" placeholder="请输入建议" />-->
      <!--</a-form-model-item>-->
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        name: '',
        suggestion: '',
      },
      rules: {
        name: [{ required: true, message: '请输入指标项信息', trigger: 'blur' }],
      },
      currIndex: -1,
    }
  },
  created() {},
  methods: {
    showModal(data, index) {
      this.form = { ...data }
      this.visible = true
      this.currIndex = index
    },
    hideModal() {
      this.visible = false
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        this.$emit('updateRow', this.form, this.currIndex)
        this.hideModal()
      })
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less"></style>
